export default __webpack_public_path__ + "static/media/PlasmaCutterImg.02fe2814.jpg";